<template>
  <div>
    <navigator class='header' title="登录授权" :routePath='"/"'></navigator>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Toast,Icon } from 'vant';

export default {
  data() {
    return {
      resCode: '',
      token: '',
      ukey: '',

      duration: 150000,
    };
  },
  methods: {
    ...mapMutations(['change_token', 'change_user']),
    init() {
      if (this.resCode === '10000') {
        this.change_token(this.$route.query.token);
        this.getUserInfo(this.$route.query.token);
        this.$router.push(this.curPath);
        // 获取用户信息
      } else if (this.resCode === '20301') {
        this.$router.replace({ path: '/auth/regist', query: { ukey: this.$route.query.ukey } });
      }else if(this.resCode === '20303'){
          Toast({
            message: '请先关注天安运营公众号，长按图片识别',
            icon: 'http://home.tianan.net/alliance/images/qrcode.png',
            duration:'150000'
          });
      } else {
        let errMsg = '';
        if (this.resCode === '10009') {
          errMsg = '账号已冻结,TOKEN已失效';
        } else if (this.resCode === '10010') {
          errMsg = '账号已注销,TOKEN已失效';
        } else if (this.resCode === '99999') {
          errMsg = '服务器异常，请稍后再试！';
        }
        Toast.fail({ duration: this.duration, message: errMsg });
        setTimeout(() => {
          this.$router.push('/');
        }, this.duration);
      }
    },
    getUserInfo(token) {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {}, {
        headers: { token: token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_user(res.resData);
        }
      });
    },
  },
  computed: {
    ...mapGetters(['curPath']),
  },
  mounted() {
    this.resCode = this.$route.query.resCode;
    this.init();
  },
};
</script>





// WEBPACK FOOTER //
// src/pages/auth/AuthorizeCb.vue